// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import '../styles/aboutus.css';

// export default function AboutUs() {
//   const { businessName, salePointName } = useParams();  
//   const [salePointData, setSalePointData] = useState(null);

// useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await fetch(`/api/salePointConfig/${businessName}/${salePointName}`);
//         if (res.status === 404) {
//           navigate('/not-found'); 
//           return;
//         }
//         if (!res.ok) throw new Error('API error');
//         const data = await res.json();
//         setSalePointData(data);
//       } catch (err) {
//         console.error('Failed to fetch sale point config:', err);
//       }
//     };
//     fetchData();
//   }, [businessName, salePointName]);

//   if (!salePointData) return <div className="aboutus-loading">Loading...</div>;

//   return (
//     <div className="aboutus-container">
//       <img
//         src={`http://localhost:8081/dinar/1/null/ecom_settings/${salePointData.salePointBannerUrl}`}
//         alt="Banner"
//         className="aboutus-banner"
//       />
//       <div className="aboutus-info">
//         <img
//           src={`http://localhost:8081/dinar/1/null/ecom_settings/${salePointData.salePointLogoUrl}`}
//           alt="Logo"
//           className="aboutus-logo"
//         />
//         <h1 className="aboutus-name">{salePointData.salePointArName}</h1>
//         <p className="aboutus-phoneaddress"> Phone Number: {salePointData.salePointPhoneNumber}</p> 
//         <p className="aboutus-desc">
//           هذا هو متجر {salePointData.businessName}، نقطة البيع: {salePointData.salePointEnName}.
//         </p>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/aboutus.css';
import GoBackButton from './GoBackButton';
import Logo from './Logo';

export default function AboutUs() {
  const { businessName, salePointName } = useParams();  
  const navigate = useNavigate();
  const [salePointData, setSalePointData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`/api/salePointConfig/${businessName}/${salePointName}`);
        if (res.status === 404) {
          navigate('/not-found');
          return;
        }
        if (!res.ok) throw new Error('API error');
        const data = await res.json();
        setSalePointData(data);
      } catch (err) {
        console.error('Failed to fetch sale point config:', err);
        navigate('/not-found');
      }
    };
    fetchData();
  }, [businessName, salePointName, navigate]);

  if (!salePointData) return <div className="aboutus-loading"><span className="loader"></span>Loading...</div>;

  return (
    <div className="aboutus-container" style={{ position: 'relative' }} >
      <div style={{ 
          position: 'sticky', 
          top: '80px', 
          left: '10px', 
          zIndex: 1000,
          alignSelf: 'flex-start'
        }}>
          <GoBackButton />
        </div>
      {/* Hero Banner Section */}

      {/* Main Info Section */}
      <div className="aboutus-main">
        <div className="aboutus-header">
          <div className="aboutus-logo-wrapper">
            <Logo
              businessName={businessName}
              salePointName={salePointName}
              className="aboutus-logo"
            />
          </div>
          <div className="aboutus-title-section">
            <h1 className="aboutus-name">{salePointData.salePointArName}</h1>
            <p className="aboutus-en-name">{salePointData.salePointEnName}</p>
          </div>
        </div>

        {/* Info Cards */}
        <div className="aboutus-info-grid">
          <div className="info-card">
            <div className="card-icon">📞</div>
            <h3>تواصل معنا عبر الرقم</h3>
            <p>{salePointData.salePointPhoneNumber}</p>
          </div>
          <div className="info-card">
            <div className="card-icon">🏢</div>
            <h3>الشركة</h3>
            <p>{salePointData.businessName}</p>
          </div>
          <div className="info-card">
            <div className="card-icon">📍</div>
            <h3>الموقع</h3>
            <p>{salePointData.salePointEnName}</p>
          </div>
        </div>

        {/* Description Section */}
        <div className="aboutus-description">
          <h2>حول متجرنا</h2>
          <p className="aboutus-desc">
            {salePointData.businessName} {salePointData.salePointArName}  هو احد المتاجر التابعة لشركة 
          </p>
          <p className="aboutus-tagline">
            نقدم أفضل المنتجات بأفضل الأسعار مع خدمة عملاء ممتازة.
          </p>
        </div>

        {/* Features Section */}
        <div className="aboutus-features">
          <h2>لماذا يختارنا العملاء؟</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-number">✓</div>
              <h4>جودة المنتجات</h4>
              <p>نقدم أفضل جودة للمنتجات التي نبيعها</p>
            </div>
            <div className="feature-item">
              <div className="feature-number">✓</div>
              <h4>أفضل الأسعار</h4>
              <p>نقدم أفضل الأسعار في السوق</p>
            </div>
            <div className="feature-item">
              <div className="feature-number">✓</div>
              <h4>توصيل سريع</h4>
              <p>توصيل سريع وموثوق</p>
            </div>
            <div className="feature-item">
              <div className="feature-number">✓</div>
              <h4>دعم العملاء</h4>
              <p>فريق دعم مخصص على مدار الساعة</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
